var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndividual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.717,
    height: 22.688,
    viewBox: "0 0 33.717 22.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "camera",
    d: "M32.39,50.883a.943.943,0,0,1-.025.281l-2.08,8.319a.946.946,0,0,1-.912.716l-12.478.063H4.412a.945.945,0,0,1-.917-.717l-2.08-8.35a.944.944,0,0,1-.025-.289,1.986,1.986,0,1,1,1.856-.361l2.6,2.623a3.534,3.534,0,0,0,5.327-.36l4.279-5.67a1.986,1.986,0,1,1,2.837-.034l0,0,4.248,5.686a3.546,3.546,0,0,0,2.828,1.417,3.507,3.507,0,0,0,2.5-1.034l2.62-2.62a1.985,1.985,0,1,1,1.9.325ZM30.083,63.224a.945.945,0,0,0-.945-.945H4.685a.945.945,0,0,0-.945.945v2.269a.945.945,0,0,0,.945.945H29.137a.945.945,0,0,0,.945-.945Z",
    transform: "translate(0 -43.75)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividual);
export default __webpack_public_path__ + "static/media/individual.bfc38b5b627157661116da4cdba9ac21.svg";
export { ForwardRef as ReactComponent };